"use client"

import { useUbStorefrontState } from "@/store/ubStorefrontState"
import { AlertTriangleIcon } from "lucide-react"
import { useTranslations } from "next-intl"

import { Button } from "@/components/ui/components"

export default function BasketLoadErrorClient() {
  const t = useTranslations("storefront")
  const { basketLoadError } = useUbStorefrontState()

  if (!basketLoadError) {
    return null
  }

  return (
    <div className="mx-auto mt-36 mb-6 flex w-full max-w-7xl px-2 md:px-0">
      <div className="flex w-full flex-col gap-4 border border-primary/40 bg-white p-6 shadow-sm">
        <div className="flex items-start gap-3">
          <AlertTriangleIcon className="mt-1 size-5 shrink-0 text-primary" aria-hidden="true" />
          <div className="flex flex-col gap-2">
            <p className="font-bold">{t("basket.load_error.title")}</p>
            <p className="text-sm text-gray-600">{t("basket.load_error.message")}</p>
          </div>
        </div>
        <Button type="button" size="defaultNoGrow" className="w-fit" onClick={() => window.location.reload()}>
          {t("basket.load_error.reload")}
        </Button>
      </div>
    </div>
  )
}
